import { render, staticRenderFns } from "./TaskTypeModal.vue?vue&type=template&id=3737ebcf&"
import script from "./TaskTypeModal.vue?vue&type=script&lang=js&"
export * from "./TaskTypeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports